import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import { FC, ReactNode } from 'react';

type FieldLabelWithTooltipProps = {
  htmlFor?: string
  label: string
  tooltip: string
  children?: ReactNode
};

/** Accessible field label with a hover/focus info tooltip. */
export const FieldLabelWithTooltip: FC<FieldLabelWithTooltipProps> = ({
  htmlFor,
  label,
  tooltip,
  children,
}) => (
  <label htmlFor={htmlFor} className="mb-1 flex items-center gap-1 text-sm font-raleway text-ink">
    <span>{label}</span>
    <Tooltip title={tooltip} enterDelay={200}>
      <button
        type="button"
        className="inline-flex text-muted hover:text-ink"
        aria-label={`${label} help`}
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </button>
    </Tooltip>
    {children}
  </label>
);
